import crypto from 'crypto-js';
import secretsData from '../constants/secrets';

const decryptAes = (value) => {
  try {
    if(!value) return value;

    const bytes = crypto.AES.decrypt(value, secretsData.encryt);
    const decryptedData = bytes.toString(crypto.enc.Utf8);

    return JSON.parse(decryptedData);
  }
  catch {
    return null;
  }
}

export default decryptAes
